/**
 * We have too many way of handling locales, deezer-seo format is the way forward but we need
 * to handle backward compatiblity with legacy locales. We have the following legacy locales:
 * - "ISO": fr-FR
 * - "legacy": 2 letters some region are set instead of countries -> br, us
 */

const LOCALE_TO_COUNTRY = {
  ja: 'JP',
  cs: 'CZ',
  da: 'DK',
  sv: 'SE',
  sl: 'SI',
  sq: 'AL',
  sr: 'RS',
  uk: 'UA',
  he: 'IL',
  ko: 'KR'
};
export const getSSGCountryFromLocale = locale => {
  var _LOCALE_TO_COUNTRY;
  return (_LOCALE_TO_COUNTRY = LOCALE_TO_COUNTRY[locale]) != null ? _LOCALE_TO_COUNTRY : locale.toUpperCase();
};
const LOCALE_TO_LEGACY_LOCALE = {
  'en-us': 'us',
  'es-es': 'es',
  es: 'mx',
  'pt-br': 'br',
  zh: 'cn'
};
export const getLegacyLocaleFromLocale = locale => {
  return LOCALE_TO_LEGACY_LOCALE[locale] || locale;
};
export const getLocaleFromLegacyLocale = legacyLocale => {
  return Object.keys(LOCALE_TO_LEGACY_LOCALE).find(value => LOCALE_TO_LEGACY_LOCALE[value] === legacyLocale) || legacyLocale;
};
const LOCALE_TO_ISO_LOCALE = {
  ar: 'ar-EG',
  cs: 'cs-CZ',
  da: 'da-DK',
  en: 'en-GB',
  es: 'es-MX',
  he: 'he-IL',
  ja: 'ja-JP',
  ko: 'ko-KR',
  ms: 'ms-MK',
  no: 'nb-NO',
  sq: 'sq-AL',
  sr: 'sr-RS',
  sv: 'sv-SE',
  uk: 'uk-UA',
  zh: 'zh-CN'
};

/**
 * Transforms a deezer-seo locale into a ISO local (en-us -> en-US)
 * @param locale - current deezer-seo local
 */
export const getISOLocaleFromLocale = locale => {
  if (locale.length === 2) {
    return LOCALE_TO_ISO_LOCALE[locale] || `${locale}-${locale.toUpperCase()}`;
  }
  return `${locale.slice(0, 2)}-${locale.slice(3, 5).toUpperCase()}`;
};
//# sourceMappingURL=deezer-seo.js.map